module.exports = __webpack_public_path__ + "976297ddf6a86ba03bebde91bd060774.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-sunset-lake.png
// module id = 1016
// module chunks = 0